import SplitMark from '@/pages/datastores/document-detail/paragraph/SplitMark.tsx'
import type { Editor } from '@/pages/datastores/document-detail/paragraph/editor/index.ts'
import {
  RenderReactComponent,
  moveCaret,
  insertElementToSelection,
} from './dom.tsx'

export function withDynamicInsertSplitMark(instance: Editor) {
  const editor = instance.editor
  if (editor) {
    editor.addEventListener('keydown', e => {
      if (e.code === 'Enter' && !e.shiftKey) {
        e.preventDefault()

        const splitMark = document.createElement('p')
        splitMark.className = 'paragraph-split-mark'
        RenderReactComponent(SplitMark, splitMark)

        insertElementToSelection(splitMark, editor)
        moveCaret(splitMark)

        /**
         * 插入之后，需要在分割线上之后补偿换行符，并且光标聚焦到当前添加的空行，否则分割线上下有空行时，光标无法聚焦
         * 1、向后补偿回车
         *    1.1、分割线后无元素，补偿一个回车
         *    1.2、分割线后是一个dom元素，并且dom内无内容，向dom内部插入一个回车
         *    1.3 分割线后是一个文本元素，并且文本无内容或者内容是一个\n，将当前文本元素替换为一个回车
         * 2、向前补偿回车
         *   2.1、分割线前无元素，补偿一个回车
         *   2.2、分割线前是一个文本元素，并且文本无内容或者内容是一个\n，将当前文本元素替换为一个回车
         *   2.3、如果前面还是一个分割线，那么需要补偿一个回车
         * 3、向前插入回车的时候不需要调整光标，向后插入元素的时候需要光标移到插入的元素之后
         */
        const nextNode = splitMark.nextSibling
        if (!nextNode) {
          // 1.1
          console.log('1.1  ')
          const p = document.createElement('p')
          p.innerHTML = '<br/>'
          splitMark.parentElement?.appendChild(p)
          moveCaret(p)
        } else if (
          nextNode instanceof HTMLElement &&
          !nextNode.textContent?.trim()
        ) {
          // 判断dom中是否有Image节点，如果有，该dom就不算空
          const imageElements = nextNode.querySelectorAll('img')
          if (!imageElements.length) {
            // 1.2
            nextNode.innerHTML = '<br/>'
            moveCaret(nextNode)
          }
        } else if (
          nextNode.nodeType === Node.TEXT_NODE &&
          (!nextNode.textContent?.trim() || nextNode.textContent === '\n')
        ) {
          // 1.3
          console.log('1.3')
          const p = document.createElement('p')
          p.innerHTML = '<br/>'
          splitMark.parentElement?.replaceChild(p, nextNode)
          moveCaret(p)
        }

        const prevNode = splitMark.previousSibling
        if (!prevNode) {
          // 2.1
          const p = document.createElement('p')
          p.innerHTML = '<br/>'
          splitMark.parentElement?.insertBefore(p, splitMark)
        } else if (
          prevNode.nodeType === Node.TEXT_NODE &&
          (!prevNode.textContent?.trim() || prevNode.textContent === '\n')
        ) {
          // 2.2
          const p = document.createElement('p')
          p.innerHTML = '<br/>'
          splitMark.parentElement?.replaceChild(p, prevNode)
        } else if (
          prevNode instanceof HTMLElement &&
          prevNode.className === 'paragraph-split-mark'
        ) {
          // 2.3
          const p = document.createElement('p')
          p.innerHTML = '<br/>'
          splitMark.parentElement?.insertBefore(p, splitMark)
        }

        instance.listener.onChange?.()
      }
    })
  }
}

export function getSplitValue(
  splitMark: HTMLElement,
  editorInstance: Editor,
): [string, string] {
  const editorEl = editorInstance.editor
  let flag = false
  const beforeFragment = document.createDocumentFragment()
  const afterFragment = document.createDocumentFragment()

  const childNodes = editorEl?.childNodes ?? []
  for (let i = 0; i < childNodes.length; i++) {
    const element = childNodes[i] as HTMLElement
    if (element.className === 'paragraph-split-mark') {
      if (element === splitMark) {
        flag = true
      }
      continue
    }
    if (!flag) {
      beforeFragment.appendChild(element.cloneNode(true))
    } else {
      afterFragment.appendChild(element.cloneNode(true))
    }
  }

  const beforeValue = editorInstance.parseToMarkdown(beforeFragment)
  const afterValue = editorInstance.parseToMarkdown(afterFragment)

  return [beforeValue, afterValue]
}

export function registrySplitMarkEvent(instance: Editor) {
  const editor = instance.editor
  if (editor) {
    editor.onclick = (e: any) => {
      let el: HTMLElement | null = e.target

      while (el && el !== editor && el.className !== 'paragraph-split-mark') {
        el = el.parentElement
      }

      if (el && el.className === 'paragraph-split-mark') {
        const splitValue = getSplitValue(el, instance)
        instance.listener?.onSplit?.(splitValue)
      }
    }
  }
}
